import React, {useState} from 'react';
import PageHeader from "../../components/PageHeader";
import {Button} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {customTableStyles} from "../../utils";
import UsersModal from "./UsersModal";
import UserEditModal from './EditModal';

const UsersPage = () => {
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Role',
            selector: row => row.role,
            sortable: true,
        },
        {
            name: 'Added By',
            sortable: true,
            cell: (row) => (
                <span className='badge bg-info'>{row.addedBy}</span>
            ),
        },
        {
            name: 'Updated By',
            cell: (row) => (
                <span className='badge bg-info'>{row.updatedBy}</span>
            ),
            sortable: true,
        },
        {
            name: 'Created At',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated At',
            selector: row => row.updatedAt,
            sortable: true,
        },
        {
            name: 'Action',
            cell: (row, i) => {
                return (
                    <>
                        <div className="hstack gap-1 fs-1">
                            {/* <a
                                aria-label="anchor"
                                href="javascript:void(0);"
                                className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-eye-fill"/>
                            </a> */}
                            <Button
                                aria-label="Edit"
                                onClick={() => setIsEdit(true)}
                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-edit-line" />
                            </Button>
                            <a
                                aria-label="anchor"
                                href="javascript:void(0);"
                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                            >
                                <i className="ri-delete-bin-7-line"/>
                            </a>
                        </div>
                    </>
                )
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const data = [
        {
            name: 'John Doe',
            email: 'john.doe@example.com',
            role: 'Admin',
            addedBy: 'Admin A',
            updatedBy: 'User A',
            createdAt: '2024-03-09T12:00:00',
            updatedAt: '2024-03-09T13:30:00',
        },
        {
            name: 'Jane Smith',
            email: 'jane.smith@example.com',
            role: 'User',
            addedBy: 'Admin B',
            updatedBy: 'User B',
            createdAt: '2024-03-08T10:30:00',
            updatedAt: '2024-03-09T09:15:00',
        },
        {
            name: 'Alice Johnson',
            email: 'alice.johnson@example.com',
            role: 'Admin',
            addedBy: 'Admin C',
            updatedBy: 'User C',
            createdAt: '2024-03-07T15:45:00',
            updatedAt: '2024-03-08T14:20:00',
        },
        {
            name: 'Bob Brown',
            email: 'bob.brown@example.com',
            role: 'User',
            addedBy: 'Admin D',
            updatedBy: 'User D',
            createdAt: '2024-03-06T11:20:00',
            updatedAt: '2024-03-07T16:40:00',
        },
        {
            name: 'Eva Martinez',
            email: 'eva.martinez@example.com',
            role: 'Admin',
            addedBy: 'Admin E',
            updatedBy: 'User E',
            createdAt: '2024-03-05T09:10:00',
            updatedAt: '2024-03-06T10:25:00',
        },
        {
            name: 'Michael Johnson',
            email: 'michael.johnson@example.com',
            role: 'User',
            addedBy: 'Admin F',
            updatedBy: 'User F',
            createdAt: '2024-03-04T14:30:00',
            updatedAt: '2024-03-05T11:55:00',
        },
        {
            name: 'Olivia White',
            email: 'olivia.white@example.com',
            role: 'Admin',
            addedBy: 'Admin G',
            updatedBy: 'User G',
            createdAt: '2024-03-03T08:45:00',
            updatedAt: '2024-03-04T17:30:00',
        },
        {
            name: 'David Lee',
            email: 'david.lee@example.com',
            role: 'User',
            addedBy: 'Admin H',
            updatedBy: 'User H',
            createdAt: '2024-03-02T10:00:00',
            updatedAt: '2024-03-03T12:20:00',
        },
        {
            name: 'Sophia Brown',
            email: 'sophia.brown@example.com',
            role: 'Admin',
            addedBy: 'Admin I',
            updatedBy: 'User I',
            createdAt: '2024-03-01T13:20:00',
            updatedAt: '2024-03-02T09:45:00',
        },
        {
            name: 'William Davis',
            email: 'william.davis@example.com',
            role: 'User',
            addedBy: 'Admin J',
            updatedBy: 'User J',
            createdAt: '2024-02-29T09:30:00',
            updatedAt: '2024-03-01T10:55:00',
        },
    ];
    
    return (
        <>
            <PageHeader name="Users"/>


            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    <div className="col-auto p-0 d-flex gap-1">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => setIsShow(true)}
                                        >
                                            Create User
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line"/>
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <UsersModal
                show={isShow}
                handleClose={() => setIsShow(false)}
            />
            <UserEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            />
        </>
    );
};

export default UsersPage;